import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class IncentiviService {

  protected baseUrl: string = environment.apiUrl;
  //protected baseUrl: string = 'http://localhost:8111'
  protected endpoint: string = 'tls-fa-bandi/incentive';
  userId: string;

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  countNewIncentivi() {
    // Execute the API call and return the body of the response
    return this.httpClient
      .get<number>(`${this.baseUrl}/${this.endpoint}/count-new`, {
        observe: 'response'
      })
      .pipe(map(res => res.body))
      .pipe(map(res => {
        return res;
      }));
  }

}
